import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import wfeTokenRefresh from '../util/wfeTokenRefresh';
import { bindChannelChunking } from '../util/bindChannelChunking';
import { getJwt } from '../util/jwtLocalstorage';
import { uploadFailed, uploadSuccess, uploadToS3, setTraceId, uploadStart } from './upload';
import { captureError } from '../util/errors';
import { getPublicProxyUrl as getSiteConfigExpressKeysUrl } from '../util/helpers';
export var expressKeysRequest = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(proxyApiUrl) {
    var jwt, headers;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          jwt = getJwt();
          headers = {
            'chegg-wfe-token': "Bearer ".concat(jwt),
            'Content-Type': 'application/json'
          };
          _context.next = 4;
          return fetch("".concat(proxyApiUrl, "/expressKeys/"), {
            method: 'GET',
            headers: headers
          });
        case 4:
          return _context.abrupt("return", _context.sent);
        case 5:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return function expressKeysRequest(_x) {
    return _ref.apply(this, arguments);
  };
}();
export var getExpressKeys = /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(url, authApiUrl, onAuthUpdate) {
    var response, _yield$response$json, data;
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) switch (_context2.prev = _context2.next) {
        case 0:
          _context2.prev = 0;
          if (getJwt()) {
            _context2.next = 4;
            break;
          }
          _context2.next = 4;
          return wfeTokenRefresh(authApiUrl, undefined, onAuthUpdate);
        case 4:
          _context2.next = 6;
          return expressKeysRequest(url);
        case 6:
          response = _context2.sent;
          if (!(response.status !== 200)) {
            _context2.next = 13;
            break;
          }
          _context2.next = 10;
          return wfeTokenRefresh(authApiUrl, response, onAuthUpdate);
        case 10:
          _context2.next = 12;
          return expressKeysRequest(url);
        case 12:
          response = _context2.sent;
        case 13:
          _context2.next = 15;
          return response.json();
        case 15:
          _yield$response$json = _context2.sent;
          data = _yield$response$json.data;
          return _context2.abrupt("return", data);
        case 20:
          _context2.prev = 20;
          _context2.t0 = _context2["catch"](0);
          console.error('FAILED TO GET KEYS', _context2.t0);
        case 23:
        case "end":
          return _context2.stop();
      }
    }, _callee2, null, [[0, 20]]);
  }));
  return function getExpressKeys(_x2, _x3, _x4) {
    return _ref2.apply(this, arguments);
  };
}();
export var subscribeToChannel = function subscribeToChannel() {
  return /*#__PURE__*/function () {
    var _ref4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(dispatch, getState, _ref3) {
      var pusherClient, handleError, keys, _getState, site, authApiUrl, onAuthUpdate, expressKeysUrl;
      return _regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) switch (_context3.prev = _context3.next) {
          case 0:
            pusherClient = _ref3.pusherClient;
            handleError = function handleError(error) {
              if (error) {
                captureError(error);
              }
              dispatch(uploadFailed());
              return;
            };
            _context3.prev = 2;
            _getState = getState(), site = _getState.site, authApiUrl = _getState.authApiUrl, onAuthUpdate = _getState.onAuthUpdate;
            expressKeysUrl = getSiteConfigExpressKeysUrl(site);
            dispatch(uploadStart());
            _context3.next = 8;
            return getExpressKeys(expressKeysUrl, authApiUrl, onAuthUpdate);
          case 8:
            keys = _context3.sent;
            if (keys) {
              _context3.next = 11;
              break;
            }
            throw new Error('could not fetch keys');
          case 11:
            _context3.next = 13;
            return pusherClient.initialize(site, keys.appKey, keys.cluster,
            // eslint-disable-next-line @typescript-eslint/no-empty-function
            function () {},
            // eslint-disable-next-line @typescript-eslint/no-empty-function
            function () {});
          case 13:
            dispatch(setTraceId({
              traceId: keys.traceId
            }));
            if (pusherClient.uploadChannel) {
              _context3.next = 17;
              break;
            }
            _context3.next = 17;
            return pusherClient.subscribe(keys.channelName);
          case 17:
            if (pusherClient.uploadChannel) {
              _context3.next = 19;
              break;
            }
            throw new Error('Error in pusher subscription, unable to get uploadChannel');
          case 19:
            dispatch(uploadToS3);
            bindChannelChunking(pusherClient.uploadChannel, 'uploadPaper', function (data) {
              try {
                var message = data.message,
                  error = data.error;
                if (error) {
                  throw new Error(error);
                }
                if (message && message.url) {
                  dispatch(uploadSuccess(message.url));
                }
              } catch (error) {
                handleError(error);
                pusherClient.unsubscribe(keys ? keys.channelName : undefined);
              }
            });
            _context3.next = 27;
            break;
          case 23:
            _context3.prev = 23;
            _context3.t0 = _context3["catch"](2);
            pusherClient.unsubscribe(keys ? keys.channelName : undefined);
            handleError(_context3.t0);
          case 27:
          case "end":
            return _context3.stop();
        }
      }, _callee3, null, [[2, 23]]);
    }));
    return function (_x5, _x6, _x7) {
      return _ref4.apply(this, arguments);
    };
  }();
};